/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  GET_ALL_USERS,
  SET_SELECTED_USER,
  SET_FILTERED_USERS,
  SET_NO_ITEM,
  SET_SEARCH_VALUE,
  RESET_USERS,
  SET_SELECTED_USER_DETAILS,
  RESET_SELECTED_USER_DETAILS,
  SET_IDPS,
  SET_SEARCH_KEY,
  SET_IDP_ROLES,
  SET_ROLES_TO_ASSIGN
} from './types';
import { SEARCH_FILTER_KEYS } from '../../container/Users/constants';
import { compareByProperty } from '../../utility/commonUtility';
import { Page } from "../../models/Users/UserContracts";

export const userReducerInitialState: any = {
  users: [],
  filteredUsers: [],
  selectedItem: {},
  selectedItemDetails: {},
  page: {},//new Page(),
  noItem: false,
  searchValue: '',
  searchKey: SEARCH_FILTER_KEYS.filter((item: any) => item.default)[0],
  idps: [],
  idpRoles: [],
  rolesToAssign: []
}

export const userReducer = (state = userReducerInitialState, action: any) => {
  switch (action.type) {
    case SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue,
        noItem: false
      }
    case SET_SEARCH_KEY:
      return {
        ...state,
        searchKey: action.searchKey
      }
    case GET_ALL_USERS:
      return {
        ...state,
        users: state.users && state.users.length > 0 ? state.users : action.users,
        filteredUsers: action.filteredUsers,
        selectedItem: action.filteredUsers[0],
        selectedItemDetails: {},
        page: action.page,
        noItem: false
      }
    case SET_SELECTED_USER:
      return {
        ...state,
        selectedItem: action.selectedItem,
        noItem: false
      }
    case SET_SELECTED_USER_DETAILS:
      return {
        ...state,
        selectedItemDetails: action.selectedItemDetails,
        noItem: false
      }
    case RESET_SELECTED_USER_DETAILS:
      return {
        ...state,
        selectedItemDetails: {},
        noItem: false
      }
    case SET_FILTERED_USERS:
      return {
        ...state,
        filteredUsers: action.filteredUsers,
        selectedItem: action.filteredUsers[0],
        selectedItemDetails: {},
        page: action.page,
        noItem: false
      }
    case SET_NO_ITEM:
      return {
        ...state,
        users: action.users,
        filteredUsers: action.filteredUsers,
        selectedItem: action.filteredUsers[0],
        selectedItemDetails: {},
        page: new Page(),
        noItem: true,
      }
    case RESET_USERS:
      return {
        ...state,
        users: [],
        filteredUsers: [],
        selectedItemDetails: {},
        page: new Page()
      }
    case SET_IDPS:
      return {
        ...state,
        idps: action.idps
      }
    case SET_IDP_ROLES:
      return {
        ...state,
        idpRoles: action.idpRoles
      }
    case SET_ROLES_TO_ASSIGN:
      return {
        ...state,
        rolesToAssign: [...action.rolesToAssign].sort(compareByProperty('name'))
      };
    default:
      return state;
  }
}
